<template>
  <div class="index">
    <van-loading size="36px" v-if="loadingShow" color="red" type="spinner" vertical></van-loading>
    <!-- 内容 start -->
    <!--顶部 start-->
    <div class="member-top">
      <div class="head-wrap">
        <div class="head vertical-box">
          <img :src="ykshow==true?headImg:headIcon" :onerror="defaultImg"/>
        </div>
        <div class="right">
          <div class="name">
            <div class="text-ellipsis txt">{{username}}</div>
            <img :src="ykshow==true?'../../assets/img/ico.png':userInfo.level_icon" :onerror="defaultIco"
                 class="ico ico-jp"/>
          </div>
          <div class="index-btn" v-if="ykshow==true" @click="cwTap()">成为会员</div>
          <span v-else>No.{{userInfo.codeid}}</span>
        </div>
      </div>
      <!-- 用户显示 start -->
      <ul class="top-list clearfix">
        <li class="item" @click="linkTap(ykshow,$event)" data-url="/score" data-name="jf">
          <div class="num">{{ykshow==false?userInfo.score:'*'}}</div>
          <span>积分</span>
        </li>
        <li @click="linkTap(ykshow,$event)" class="item" data-url="/score" data-name="cz">
          <div class="num">{{ykshow==false?userInfo.val:'*'}}</div>
          <span>储值</span>
        </li>
        <li class="item" @click="linkTap(ykshow,$event)" data-url="/grade" data-name="">
          <div class="num">{{ykshow==false?userInfo.level_title:'*'}}</div>
          <span>会员</span>
        </li>
      </ul>
      <!-- 用户显示 end -->
    </div>
    <!--顶部 end-->
    <div class="pd-lr-30">
      <!--我的卡卷 start-->
      <div class="member-box mt-30">
        <van-cell value="我的卡券" :border="false"/>
        <ul class="list">
          <li class="item" @click="couponTap(ykshow,$event)" data-id="0" data-type="1">
            <div class="num">{{ykshow==false?indexInfo.ty_num:'*'}}</div>
            <span>通用券</span>
          </li>
          <li class="item" @click="couponTap(ykshow,$event)" data-id="1" data-type="3">
            <div class="num">{{ykshow==false?indexInfo.yq_num:'*'}}</div>
            <span>友情券</span>
          </li>
          <li class="item" @click="couponTap(ykshow,$event)" data-id="2" data-type="4">
            <div class="num">{{ykshow==false?indexInfo.lm_num:'*'}}</div>
            <span>联盟券</span>
          </li>
          <li class="item" @click="couponTap(ykshow,$event)" data-id="3" data-type="2">
            <div class="num">{{ykshow==false?indexInfo.birthday_num:'*'}}</div>
            <span>尊享券</span>
          </li>
        </ul>
      </div>
      <!--我的卡卷 end-->
      <!--常规功能 start-->
      <div class="member-box mt-30">
        <van-cell value="常规功能" :border="false"/>
        <div class="list gn-list clearfix">
          <router-link to="/activeList" class="item">
            <i class="ico van-icon-ico-yx"></i>
            <div>营销活动</div>
          </router-link>
          <router-link to="/shop" class="item" v-if="ykshow==false">
            <i class="ico van-icon-ico-jf"></i>
            <div>积分商城</div>
          </router-link>
          <router-link to="/warranty" class="item" v-if="ykshow==false && merchant !='bgclf1111'">
            <i class="ico van-icon-ico-bd"></i>
            <div>电子质保单</div>
          </router-link>
          <router-link :to="{path:'/detail',query:{name:'pp'}}" class="item">
            <i class="ico van-icon-ico-js"></i>
            <div>品牌介绍</div>
          </router-link>
          <router-link to="/contact" class="item" v-if="ykshow==false">
            <i class="ico van-icon-ico-lx"></i>
            <div>联系导购</div>
          </router-link>
        </div>
      </div>
      <!--常规功能 end-->
    </div>
    <div class="store_name" v-if="merchant_title!=''">当前门店：{{merchant_title}}</div>

    <img :src="indexInfo.merchant_logo" class="logo" :onerror="defaultLogo"/>
    <!-- 注册 start -->
    <van-overlay :show="show">
      <div class="wrapper public-popup index-popup">
        <div class="block">
          <div class="box">
            <div class="title">成为会员</div>
            <van-form validate-first @submit="onSubmit">
              <van-field v-model="username" name="user" label="姓名" placeholder="请输入姓名"
                         :rules="[{ required: true},{ pattern: /^(.){2,20}$/,message:'至少两位,中/英/数字均可'}]"/>
              <van-field v-model="phonenumber" type="tel" name="tel" label="+86" placeholder="请输入手机号码"
                         :rules="[{ required: true},{pattern:/^1[3456789]\d{9}$/,message:'请输入正确的手机号码'}]"/>
              <van-field name="radio" v-model="radio" label="性别">
                <template #input>
                  <van-radio-group v-model="radio" direction="horizontal">
                    <van-radio name="1" checked-color="#CA0A1B">男</van-radio>
                    <van-radio name="2" checked-color="#CA0A1B">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field class="date" readonly clickable name="date" label="生日" :value="value | formatter"
                         placeholder="请选择生日" :rules="[{ required: true}]" @click="showDate = true"/>
              <van-popup v-model="showDate" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate"
                                     @confirm="onConfirm" @cancel="showDate = false"/>
              </van-popup>
              <van-button round block type="info" native-type="submit">提交</van-button>
            </van-form>
          </div>
          <van-icon name="ico-close" @click="show = false"/>
        </div>

      </div>
    </van-overlay>
    <!-- 注册 end -->
    <!-- 关注公众号 start -->
    <van-overlay :show="gzhshow">
      <div class="wrapper public-popup">
        <div class="block">
          <div class="public-hb gzhimg">
            <div class="img"><img :src="gzhImg"/></div>
            <div>扫码关注公众号</div>
          </div>
          <van-icon name="ico-close" @click="gzhshow = false"/>
        </div>
      </div>
    </van-overlay>
    <!-- 关注公众号 end -->
    <!--微信聊聊 start-->
    <!-- <van-dialog v-model="wechartShow" title="" show-cancel-button confirmButtonText= "不再弹出" @confirm='confirmCode()' @cancel='cancelCode()'  cancelButtonText='关闭'>
       <div class="dialog-msg"><img :src="worker.icon" style="width: 60%;"/></div>
     </van-dialog> -->
    <div class="code-popup" v-if="wechartShow">
      <div class="box">
        <img :src="worker.icon" style="width: 60%;"/>
        <div class="font">识别二维码添加您的专属导购</div>
        <div class="flex-c-b bd-t">
          <div class="btn" @click="codeCancel()" style="color:#fff; background: #3f95e2;">关闭</div>
          <div class="btn" @click="confirmCancel()">不再弹出</div>
        </div>
      </div>
    </div>
    <!--微信聊聊 end-->
    <!-- 内容 end -->
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Loading, Toast} from 'vant';

  Vue.use(Toast);
  Vue.use(Loading);
  export default {
    name: 'index',
    data() {
      return {
        loadingShow: true,
        show: false,
        radio: '1',
        username: '',
        phonenumber: '',
        value: '',
        showDate: false,
        minDate: new Date(1949, 10, 1),
        maxDate: new Date(),
        currentDate: new Date(),
        indexInfo: [],
        userInfo: [],
        defaultImg: '', //默认头像
        defaultIco: '', //默认图标
        defaultLogo: '', //默认logo
        headImg: '',
        ykshow: false,
        headIcon: '',
        subscribe: '',//是否关注公众号
        gzhshow: false,
        gzhImg: '',
        worker: '',
        wechartShow: false,
        merchant_title: '',
        isAddListener: true,
        is_show_pop: false,

        wx_openid: '',//oV0_T5qgQQsFgqtCM78BYPWQAUCU
        uid: '',
        token: '',
        merchant: '',
        sub_merchant: '',
      }
    },

    //时间过滤
    filters: {
      formatter(date) {
        if (date == "" || date == null) {
          return;
        } else {
          date = new Date(date);
          var m = date.getMonth() + 1;
          var d = date.getDate();
          if (m < 10) {
            m = '0' + m
          }
          if (d < 10) {
            d = '0' + d
          }
          return `${date.getFullYear()}-${m}-${d}`; //精确到具体时间的在后面继续拼加
        }
      }
    },
    beforeCreate() {
      // 修改背景色
      document.querySelector('body').setAttribute('style', 'background-color:#F1F1F1')
    },
    mounted() {
      var that = this;
      var isHref = window.location.href;
      var workId = that.utils.getParam("worker_id");
      var cardId = that.utils.getParam("card_id");

      //绑定会员
      var work_num = sessionStorage.getItem('workId');
      if (that.utils.isnull(work_num)) {
        if (!that.utils.isnull(workId)) {
          sessionStorage.setItem('indexCount', 0);
          sessionStorage.setItem('workId', workId);
        }
      }

      //登录
      if (that.utils.isnull(that.merchant)) {

        var merchant = that.utils.getParam("merchant_number");
        console.log("地址上的主门店id: ", merchant);
        sessionStorage.setItem('merchant', merchant)
        that.merchant = merchant;

        var sub_merchant = that.utils.getParam("sub_merchant") || '';
        console.log("地址上的子门店id: ", sub_merchant);

        var save_merchant = localStorage.getItem('save_merchant') || '';
        console.log("公众号选择的门店id: ", save_merchant);
        // alert("save_merchant:"+save_merchant);

        //如果地址没有子门店id, 判断是否在公众号选择门店id
        if (that.utils.isnull(sub_merchant)) {
          if (!that.utils.isnull(save_merchant) && save_merchant != merchant && !workId) {
            sub_merchant = save_merchant;
          }
        }
        localStorage.setItem(merchant + '_sub_merchant', sub_merchant);

      }

      that.sub_merchant = localStorage.getItem(that.merchant + '_sub_merchant');
      if (that.utils.isnull(that.sub_merchant)) {
        that.sub_merchant = that.merchant;
      }

      that.merchant = sessionStorage.getItem('merchant');
      //获取缓存中的用户数据
      that.getStorageUserInfo();

      that.utils.pic(that);

      if(that.utils.isnull(that.wx_openid)){
        that.getWxOpenid()
      }else {
        if (that.utils.isnull(that.token) || that.utils.isnull(that.uid)) {
          that.login(that.wx_openid);
        } else {
          that.getUserData()
        }
      }

      that.pushHistory();

      //监听触发物理返回按钮
      window.addEventListener("popstate", function (e) {
        console.log("添加监听：popstate");
        if (that.isAddListener) {
          that.isAddListener = true;
          that.f_close();//执行关闭浏览器窗口，返回公众号首页
        }
      }, false);

    },
    beforeDestroy() {
      var that = this;
      console.log("beforeDestroy");
      window.removeEventListener("popstate", that.print(), false);

    },
    methods: {
      print() {
        this.isAddListener = false;
        console.log("解除绑定isAddListener：" + this.isAddListener);
      },
      
      //获取缓存中的用户信息
      getStorageUserInfo(){
        var that = this;
        that.wx_openid = localStorage.getItem(that.sub_merchant+'_openid') || '';
        that.token = localStorage.getItem(that.sub_merchant+'_token') || '';
        that.uid = localStorage.getItem(that.sub_merchant+'_uid') || '';
        that.nickname = localStorage.getItem(that.sub_merchant+'_nickname') || '';
        that.headImage = localStorage.getItem(that.sub_merchant+'_headImage') || '';
      },
      //清除缓存
      clearStorageInfo(){
        var that = this;
        localStorage.setItem(that.sub_merchant+'_token', '');
        localStorage.setItem(that.sub_merchant+'_uid', '');
        localStorage.setItem(that.sub_merchant+'_openid', '');
        localStorage.setItem(that.sub_merchant+'_nickname', '');
        localStorage.setItem(that.sub_merchant+'_headImage', '');
        localStorage.setItem(that.merchant + '_sub_merchant', '');

        sessionStorage.setItem('merchant', '');

        location.reload();
      },

      
      pushHistory() {
        var state = {
          title: "title",
          url: "#"
        };
        window.history.pushState(state, "title", "#");
      },

      f_close() {
        if (typeof(WeixinJSBridge) != "undefined") {
          console.log("window.close(1)");
          WeixinJSBridge.call('closeWindow');
        } else {
          if (navigator.userAgent.indexOf("MSIE") > 0) {
            if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
              window.opener = null;
              window.close();
            } else {
              window.open('', '_top');
              window.top.close();
            }
          } else if (navigator.userAgent.indexOf("Firefox") > 0) {
            window.location.href = 'about:blank ';
          } else {
            window.opener = null;
            window.open('', '_self', '');
            console.log("window.close(2)");
            window.close();
          }
        }
      },


      //关闭二维码弹窗
      codeCancel() {
        this.wechartShow = false
        sessionStorage.setItem('xzCodeCount', 1)
      },
      confirmCancel() {
        var that = this;
        this.wechartShow = false
        localStorage.setItem('xzYjHide', 1)
        this.api.closeWorkerPop({
          uid: that.uid,
          token: that.token,
          merchant_number: that.merchant,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        })
        // Cookies.set('xzYjHide',1)
      },
      //传头像
      uploadHead() {
        var that = this;
        var param = {
          merchant_number: that.merchant,
          token: that.token,
          uid: that.uid,
          wx_headimg: that.headImg,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        };
        that.api.getHead(param).then(res => {

        })
      },
      //获取卡包信息（是否注册）
      card() {
        var that = this;
        var params = {
          merchant_number: that.merchant,
          token: that.token,
          uid: that.uid,
          wx_openid: that.wx_openid,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        }
        that.api.getCard(params).then(res => {
          if (res.data.code == 200) {
            console.log(res.data.data)
            var userList = res.data.data.user_info.common_field_list
            that.username = userList[3].value;
            that.phonenumber = userList[0].value;
            var sex = userList[1].value;
            if (sex == '女') {
              that.radio = 2
            } else {
              that.radio = 1
            }
            that.value = userList[2].value;
            that.show = true;
          } else {
            // Toast(res.data.msg)
            that.addCard();
          }
        })
      },
      addCard() {
        var that = this;
        var params = {
          merchant_number: that.merchant,
          token: that.token,
          uid: that.uid,
          wx_openid: that.wx_openid,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        }
        that.api.getAddCard(params).then(res => {
          console.log(res)
          if (res.data.code == 200) {
            var data = res.data.data;
            if (that.utils.isnull(data)) {
              Toast('该公众号未开通卡包功能')
              that.show = true;
            } else {
              window.location.href = res.data.data
            }
          } else {
            Toast(res.data.msg)
          }
        })
      },
      //绑定会员
      bindWorker(id) {
        var that = this;
        var params = {
          merchant_number: that.merchant,
          token: that.token,
          uid: that.uid,
          wid: id,
          wx_openid: that.wx_openid,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        }
        sessionStorage.setItem('workCount', 1)
        that.api.getBindworker(params).then(res => {
          if (res.data.code == 200) {
            if (res.data.msg != '') {
              Toast(res.data.msg)
              sessionStorage.setItem('workId', '')
            }
          } else {
            // Toast(res.data.msg)
            // that.popup();
          }
        })
      },

      //跳转
      linkTap(status, e) {
        var url = e.currentTarget.dataset.url;
        var name = e.currentTarget.dataset.name;
        if (status == false) {
          this.$router.push(
            {path: url, query: {name: name}}
          )
        }
      },
      //卡券跳转
      couponTap(status, e) {
        var id = e.currentTarget.dataset.id;
        var type = e.currentTarget.dataset.type;
        if (status == false) {
          console.log(id, type)
          this.$router.push(
            {path: '/coupon', query: {id: id, type: type, status: 1}}
          )
        }
      },
      //日期选择
      onConfirm(val) {
        console.log(val)
        this.value = val;
        this.showDate = false;
      },

      //提示弹窗
      popup() {
        var that = this;
        that.$dialog.confirm({
          title: '温馨提示',
          message: '现在成为会员享更多惊喜优惠！',
          confirmButtonText: '现在加入',
          width: '300',
        }).then((action) => {
          // that.ykshow=false;
          that.addCard();
          // that.show = true;
        }).catch((action) => {
          that.ykshow = true;
          sessionStorage.setItem('indexCount', 1)
        });
      },
      //成为会员
      cwTap() {
        this.addCard();
      },
      //注册
      onSubmit(values) {
        var that = this,
          user = values.user,
          tel = values.tel,
          sex = values.radio,
          date = values.date;
        var params = {
          merchant_number: that.merchant,
          wx_openid: that.wx_openid,
          name: user,
          sex: sex,
          mobile: tel,
          birthday: date,
          wx_headimg: that.headImg,
          nickname: that.nickname,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        }
        that.api.getRegister(params).then(res => {
          var code = res.data.code;
          console.log(res)
          if (code == 200) {

            Toast(res.data.msg);
            that.show = false;
            that.ykshow = false;
            localStorage.setItem(that.sub_merchant+'_token', response.data.data.token);
            localStorage.setItem(that.sub_merchant+'_uid', response.data.data.uid);

            that.getUserData();

          } else if (code == 201) {

            Toast(res.data.msg);

          } else if (code == 501) {

            that.clearStorageInfo();

          } else {
            Toast(res.data.msg);
          }
        }).catch(err => {
          console.log(err)
        })
      },

      //首页接口
      getUserData() {
        var that = this;
        var param = {
          merchant_number: that.merchant,
          token: that.token,
          uid: that.uid,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        }
        that.api.getindex(param).then(res => {
          if (res.data.code == 200) {
            that.ykshow = false;
            that.indexInfo = res.data.data;
            that.userInfo = res.data.data.userinfo;
            that.headIcon = res.data.data.userinfo.wx_headimg;
            that.username = res.data.data.userinfo.name;
            that.worker = res.data.data.userinfo.worker;
            that.merchant_title = res.data.data.merchant.name;
            that.is_show_pop = res.data.data.is_show_pop

            console.log(that.userInfo)
            sessionStorage.setItem('score', res.data.data.userinfo.score);

            that.wxUser();
            that.uploadHead();
            that.loadingShow = false;

            setTimeout(function () {
              var xzCodeCount = sessionStorage.getItem('xzCodeCount')
              var xzYjHide = localStorage.getItem('xzYjHide')
              if (that.worker != null) {
                if (xzCodeCount == 1) {
                  that.wechartShow = false
                } else if (xzYjHide == 1 || that.is_show_pop) {
                  that.wechartShow = false
                } else {
                  that.wechartShow = true
                }
              } else {
                that.wechartShow = false
              }
            }, 200)
          } else if (res.data.code == 501) {

            that.clearStorageInfo();

          } else {
            Toast(res.data.msg);
          }
        })

      },

      wxUser() {
        var that = this;
        var param = {
          wx_openid: that.wx_openid,
          merchant_number: that.merchant,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        };
        var work_id = sessionStorage.getItem('workId');
        that.api.getWxUser(param).then(res => {
          console.log(res)
          if (res.data.code == 200) {
            that.subscribe = res.data.data.userinfo.subscribe;
            that.gzhImg = res.data.qrcode;
            if (that.subscribe == 0) {
              that.gzhshow = true
            } else {
              that.gzhshow = false;
              if (!that.utils.isnull(work_id)) {
                var workCount = sessionStorage.getItem('workCount')
                if (workCount != 1) {
                  that.bindWorker(work_id)
                }
              }
            }
          }
        })
      },

      //微信授权  获取openid
      getWxOpenid() {
        var that = this;
        var code = that.utils.getParam("code");
        console.log("code: ", code);
        if (!that.utils.isnull(code)) {
          sessionStorage.setItem('code', code)
        }
        if (that.utils.isnull(code)) {
          var param = {
            merchant_number: that.merchant,
            return_url: window.location.href,
            sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
          }
          console.log(param);
          that.api.getWxcode(param).then(res => {
            window.location.href = res.data.data;
            console.log(res.data.data)
          })
        } else {
          var param = {
            code:code,
            merchant_number: that.merchant,
            sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
          }
          that.api.getWxinfo(param).then(res => {
            console.log(res)
            if (res.data.code == 200) {
              that.headImg = res.data.data.userinfo.headimgurl;
              that.username = res.data.data.userinfo.nickname;
              that.radio = res.data.data.userinfo.sex;

              localStorage.setItem(that.sub_merchant+'_openid', res.data.data.openid);
              localStorage.setItem(that.sub_merchant+'_nickname', that.username);
              localStorage.setItem(that.sub_merchant+'_headImage', res.data.data.userinfo.headimgurl);

              //获取缓存中的用户数据
              that.getStorageUserInfo();

              that.login(res.data.data.openid);
            }else{
              that.loadingShow = false;
              if(res.data.code == 201){
                // //code异常
                // var param = {
                //   merchant_number: that.merchant,
                //   return_url: window.location.href,
                //   sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
                // }
                // console.log(param);
                // that.api.getWxcode(param).then(res => {
                //   window.location.href = res.data.data;
                //   console.log(res.data.data)
                // })
                //
                 Toast('获取登录信息失败，请退出公众号重试');

              }
            }
          })
        }
      },

      //登录
      login(openid) {
        var that = this;
        var params = {
          merchant_number: that.merchant,
          wx_openid: openid,
          sub_merchant: localStorage.getItem(that.merchant + '_sub_merchant'),
        }
        var work_id = sessionStorage.getItem('workId');
        that.api.getLogin(params).then(response => {
          var code = response.data.code;
          that.username = localStorage.getItem(that.sub_merchant+'_nickname');
          that.headImg = localStorage.getItem(that.sub_merchant+'_headImage');
          console.log(response)

          if (code == 200) {
            that.uid = response.data.data.id;
            that.token = response.data.data.token;

            localStorage.setItem(that.sub_merchant+'_token', response.data.data.token);
            localStorage.setItem(that.sub_merchant+'_uid', response.data.data.id);

            //获取缓存中的用户数据
            that.getStorageUserInfo();

            that.ykshow = false;
            that.getUserData()

          } else if (code == 202) {
            var count = sessionStorage.getItem('indexCount');
            that.ykshow = true;
            if (!that.utils.isnull(work_id)) {
              that.bindWorker(work_id)
            }
            if (count != 1) {
              that.popup();
            }
            that.utils.loading(that);
          } else if (code == 501) {

            that.clearStorageInfo();

          } else {
            Toast(response.data.msg)
          }
        }).catch(err => {
          console.log(err)
          // Toast(res.data.msg)
        });
      },

    }

  }
</script>

<style scoped="scoped">
  .index .ico.ico-jp {
    vertical-align: 15px;
  }

  .member-box .gn-list.list {
    display: block;
  }

  .member-box .gn-list.list .item {
    display: block;
    margin-top: 40px;
    -webkit-box-flex: inherit;
    -ms-flex: inherit;
    flex: inherit;
    float: left;
    width: 25%;
  }

  .van-grid-item {
    margin-top: 30px;
  }

  .index-btn {
    width: 130px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 24px;
    color: #CA0A1B;
    background: rgba(255, 250, 218, 0.9);
    border-radius: 32px;
  }

  .logo {
    margin: 0 auto 1.2rem !important;
  }

  .store_name {
    text-align: center;
    font-size: 0.36rem;
    padding: 0.4rem 0;
    color: rgba(35, 35, 35, .8);
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue